import * as React from 'react';

import { ControlsLayout } from '../../components/ControlsLayout';
import { DifferencesSwitchContainer } from '../DifferenciesSwitch';

export const ControlsContainer = () => {
  return (
    <ControlsLayout>
      <DifferencesSwitchContainer />
    </ControlsLayout>
  );
};
